export type Option = {
    value: string;
    label: string;
};
export const generateOptions = <T extends Record<string, string>>(
    data: T[] = [],
    valueKey: keyof T = 'id',
    labelKey: keyof T = 'name'
): Option[] => {
    return data.map(item => ({
        value: item[valueKey],
        label: item[labelKey],
        ...item
    }));
};
